import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {BusinessContextModel} from '../businessContext.model';
import {Injectable} from '@angular/core';
import {BusinessContextSummaryModel} from "../businessContextSummary.model";

@Injectable({
    providedIn: 'root'
})
export class BusinessContextSummaryConverter extends HttpModelConverter<BusinessContextSummaryModel> {

    protected createInstance(): BusinessContextSummaryModel {
        return new BusinessContextSummaryModel();
    }

    protected enrichObject(result: BusinessContextSummaryModel, src: BusinessContextSummaryModel) {

    }
}
